export default __webpack_public_path__ + "static/media/Mohammed.084de098.png";